import {
  type PopoverContentProps as KobalteContentProps,
  Popover as KobaltePopover,
  type PopoverRootProps,
} from '@kobalte/core/popover'
import { type JSX, splitProps } from 'solid-js'
import './Popover.css'

export type PopoverProps = PopoverRootProps
export type PopoverContentProps = KobalteContentProps<'div'> & JSX.HTMLAttributes<HTMLDivElement>

function Root(props: PopoverProps) {
  return <KobaltePopover gutter={8} overflowPadding={16} {...props} />
}

function Content(props: PopoverContentProps) {
  const [local, rest] = splitProps(props, ['class'])
  return <KobaltePopover.Content {...rest} class={`ds-popover ${local.class ?? ''}`} />
}

export const Popover = Object.assign(Root, {
  Root,
  Content,
  Trigger: KobaltePopover.Trigger,
  Portal: KobaltePopover.Portal,
  Anchor: KobaltePopover.Anchor,
  Arrow: KobaltePopover.Arrow,
  Title: KobaltePopover.Title,
  Description: KobaltePopover.Description,
  CloseButton: KobaltePopover.CloseButton,
})
